import { BaseConnector } from './baseConnector';

class InvitationKeyConnector extends BaseConnector {
  updateInvitationKeys(invitationGroupId, dtos) {
    var url = `${this.baseApiUrl}/invitationGroup/${invitationGroupId}/InvitationKeys`;
    return this.authPatch(url, dtos);
  }
}

export { InvitationKeyConnector };
